/* src/app/components/metrics/overview/metrics-overview.component.less */
.content-section-container {
  padding: 24px;
}
/*# sourceMappingURL=metrics-overview.component.css.map */
